export default function Footer() {
  const quickLinks = [
    { name: '热门榜单', href: '#ranking' },
    { name: '焦点专题', href: '#carousel' },
    { name: '最新快讯', href: '#updates' },
    { name: '热门话题', href: '#topics' },
    { name: '常见问题', href: '#faq' },
    { name: '联系我们', href: '#contact' },
    { name: '移动观影', href: '#app' },
    { name: '关于我们', href: '#about' },
  ];

  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
            <div className="lg:col-span-1">
              <span className="font-heading text-xl font-bold text-background-50">6080新视觉影视</span>
              <p className="mt-4 text-sm text-background-400 leading-relaxed">
                高清电影在线观看平台，提供超清画质影视、蓝光画质播放服务。
                海量片库每日更新，无需注册即可免费在线观看，畅享视觉盛宴。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <span className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center cursor-pointer hover:bg-background-700 transition-colors">
                  <i className="ri-wechat-line text-background-300 text-lg"></i>
                </span>
                <span className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center cursor-pointer hover:bg-background-700 transition-colors">
                  <i className="ri-weibo-line text-background-300 text-lg"></i>
                </span>
                <span className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center cursor-pointer hover:bg-background-700 transition-colors">
                  <i className="ri-bilibili-line text-background-300 text-lg"></i>
                </span>
              </div>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
              <ul className="space-y-2.5">
                {quickLinks.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                      className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h3>
              <p className="text-sm text-background-500">诚邀优质内容方与品牌合作</p>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50 mb-4">免责声明</h3>
              <p className="text-sm text-background-500 leading-relaxed">
                本站所有视频内容均来自互联网公开资源，
                仅供个人学习交流使用，请于下载后24小时内删除。
                如涉及版权问题请通过联系我们页面告知。
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; 2026 6080新视觉影视 - 高清电影在线观看平台。保留所有权利。
            </p>
            <p className="text-xs text-background-600">
              超清画质 · 蓝光播放 · 免费高清影视
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}